// extracted by mini-css-extract-plugin
export default {"container":"ExEdN9","extra-padding":"JetwxJ","extraPadding":"JetwxJ","logos":"giXRZW"};